import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { CTASection } from "../components/CTASection";
import { Reveal } from "../components/Reveal";
import { PROGRAMS } from "../data/content";

export default function Programs() {
  return (
    <main data-testid="programs-page">
      <PageHeader
        title="Our Programs"
        subtitle="Ten ongoing programs addressing healthcare, education, awareness and empowerment across Assam."
      />
      <section className="py-16 sm:py-20 bg-hecso-beige">
        <div className="container-hecso grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PROGRAMS.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 80}>
              <div className="group flex h-full flex-col rounded-xl border border-slate-200 bg-white overflow-hidden shadow-sm transition-shadow hover:shadow-md" data-testid={`program-detail-${p.slug}`}>
                <div className="h-48 overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-lg font-semibold text-hecso-ink">{p.title}</h3>
                  <p className="mt-2 text-sm text-hecso-muted leading-relaxed">{p.description}</p>
                  <p className="mt-3 text-sm text-hecso-muted/80 leading-relaxed">{p.details}</p>
                  <Link to="/contact" data-testid={`program-cta-${p.slug}`} className="mt-auto pt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-hecso-green hover:text-hecso-greendark transition-colors">
                    Partner With Us <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <CTASection />
    </main>
  );
}
